<template>
  <div class="page magic-bg dark:text-white">
    <navigation :key="navigationKey"/>
    <div class="row mt-3 px-3 break-words">
      <div class="col-12 md:col-6 p-4">
        <div class="card fade" v-if="$root.HasRole($store.state.adminRole)">
          <div class="flex flex-row items-center justify-between w-full">
            <p class="text-xl w-[80%]"><b class="text-gradient">Основная информация</b></p>
            <button class="rounded-button" @click="$root.ShowModal('#ChangeGeneralInfo')">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
              </svg>
            </button>
          </div>
          <div class="flex flex-col px-3 py-2">
            <div class="flex flex-col sm:flex-row sm:justify-between my-2">
              <p class="subtitle">ID</p>
              <p>{{$root.IsEmpty(user.ID)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2">
              <p class="subtitle">Логин</p>
              <p>{{$root.IsEmpty(user.Login)}}</p>
            </div>
            <div class="flex flex-col my-2">
              <p class="subtitle">Роли</p>
              <data-list :data="$root.IsEmpty(user.Roles)" />
            </div>
          </div>
        </div>
        <div class="card fade" :class="$root.HasRole($store.state.adminRole) ? 'mt-8' : ''" v-if="user.Role !== undefined || user.Role !== null">
          <div class="flex flex-row items-center justify-between w-full">
            <p class="text-xl w-[80%]"><b class="text-gradient">{{user.Role == "worker" ? "Информация работника" : user.Role == "listener" ? "Информация слушателя" :  user.Role == "student" ? "Информация студента" : "" }}</b></p>
            <button class="rounded-button" @click="$root.ShowModal('#ChangeRoleInfo')" v-if="$root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
              </svg>
            </button>
          </div>
          <div class="flex flex-col px-3 py-2">
            <div class="flex flex-col sm:flex-row sm:justify-between my-2">
              <p class="subtitle">Фамилия</p>
              <p>{{$root.IsEmpty(user.Surname)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2">
              <p class="subtitle">Имя</p>
              <p>{{$root.IsEmpty(user.Name)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2">
              <p class="subtitle">Отчество</p>
              <p>{{$root.IsEmpty(user.Lastname)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2">
              <p class="subtitle">Дата прождения</p>
              <p>{{$root.IsEmpty(user.BirthDate)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2">
              <p class="subtitle">Пол</p>
              <p>{{$root.IsEmpty(user.Gender)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="user.EducationLvl !== undefined && user.EducationLvl !== null">
              <p class="subtitle">Уровень образования</p>
              <p>{{$root.IsEmpty(user.EducationLvl)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="user.Post !== undefined && user.Post !== null">
              <p class="subtitle">Занимаемая должность</p>
              <p>{{$root.IsEmpty(user.Post.Title)}} {{$root.IsEmpty(user.Post.Date)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="user.Role == 'listener'">
              <p class="subtitle">Место обучения</p>
              <p>{{$root.IsEmpty(user.StudyPlace)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="user.Role == 'listener'">
              <p class="subtitle">Место работы</p>
              <p>{{$root.IsEmpty(user.WorkPlace)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="user.Role == 'worker'">
              <p class="subtitle">Опыт работы</p>
              <p>{{$root.IsEmpty(user.Exp)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2" v-if="user.Role == 'worker'">
              <p class="subtitle">Опыт преподавательской работы</p>
              <p>{{$root.IsEmpty(user.EducationExp)}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2">
              <p class="subtitle">ОВЗ</p>
              <p>{{$root.IsEmpty(user.OVZ) !== "Данных нет" ? user.OVZ ? "имеется" : "не имеется" : "Данных нет"}}</p>
            </div>
            <div class="flex flex-col sm:flex-row sm:justify-between my-2">
              <p class="subtitle">Инвалидность</p>
              <p>{{$root.IsEmpty(user.Disability) !== "Данных нет" ? user.Disability ? "имеется" : "не имеется" : "Данных нет"}}</p>
            </div>
            <div class="flex flex-col my-2">
              <p class="subtitle">Почты</p>
              <data-list :data="$root.IsEmpty(user.Emails)" />
            </div>
            <div class="flex flex-col my-2">
              <p class="subtitle">Номера телефонов</p>
              <data-list :data="$root.IsEmpty(user.Phones)" />
            </div>
            <div class="flex flex-col my-2" v-if="user.Qualifications !== undefined && user.Qualifications !== null">
              <p class="subtitle">Квалификации</p>
              <data-list :data="$root.IsEmpty(user.Qualifications)" />
            </div>
            <div class="flex flex-col my-2" v-if="user.Role == 'worker'">
              <p class="subtitle">Учёные степени</p>
              <data-list :data="$root.IsEmpty(user.Degrees)" />
            </div>
            <div class="flex flex-col my-2" v-if="user.Role == 'worker'">
              <p class="subtitle">Законченные учебные заведения</p>
              <data-list :data="$root.IsEmpty(user.Establishments)" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 p-4">
        <div class="card fade">
          <p class="text-xl"><b class="text-gradient">Пройденые программы</b></p>
          <div class="overflow-auto" style="max-height: 500px;" v-if="user.Programs.length > 0">
            <div class="list-container">
              <div class="list-container-item" v-for="(program, index) in user.Programs" :key="'program_' + index">
                <p>{{program.Title}}</p>
                <button class="text-blue-600 hover:animate-pulse" @click="currentProgram = index; $root.ShowModal('#SeeProgram')">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                    <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <p class="subtitle ml-2" v-else>Данных нет</p>
        </div>
      </div>
    </div>
  </div>

  <div class="modal dark:text-white" id="ChangeGeneralInfo" v-if="$root.HasRole($store.state.adminRole)" @click="$root.HideModal('#ChangeGeneralInfo')">
    <form class="modal-dialog" @submit="ChangeGeneralInfo" @click="(e)=>{e.stopPropagation()}">
      <div class="modal-dialog-header">
        <p class="modal-dialog-title">Изменение основных данных</p>
        <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeGeneralInfo')">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>
      <div class="modal-dialog-body">
        <div class="form-group w-full my-2">
          <label class="input-label">Логин</label>
          <input type="text" class="input sm:ml-auto" :value="user.Login" ref="user_login">
        </div>
        <div class="flex flex-col my-2">
          <label class="input-label mr-auto">Роли</label>
          <div class="flex flex-col overflow-y-auto max-h-40" ref="user_roles">
            <div class="flex flex-row items-center justify-start my-2" v-for="(role, index) in roles" :key="index">
              <input class="checkbox" type="checkbox" :value="role.ID" :checked="$root.HasRole(role.ID)" name="role">
              <label class="ml-2">{{role.Title}}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-dialog-footer">
        <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeGeneralInfo')">Закрыть</button>
        <button type="submit" class="modal-dialog-footer-button">Изменить</button>
      </div>
    </form>
  </div>

  <div class="modal dark:text-white" id="ChangeRoleInfo" v-if="($root.HasRole($store.state.adminRole) || $root.HasRole($store.state.methodistRole)) && (user.Role !== undefined || user.Role !== null)" @click="$root.HideModal('#ChangeRoleInfo')">
    <form class="modal-dialog" @submit="ChangeRoleInfo" @click="(e)=>{e.stopPropagation()}">
      <div class="modal-dialog-header">
        <p class="modal-dialog-title">Изменение данных {{user.Role == "worker" ? "работника" : user.Role == "listener" ? "слушателя" : "" }}</p>
        <button type="button" class="ml-auto" @click="$root.HideModal('#ChangeRoleInfo')">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </div>
      <div class="modal-dialog-body">
        <div class="form-group w-full my-2">
          <label class="input-label">Фамилия</label>
          <input type="text" class="input sm:ml-auto" :value="user.Surname" ref="user_surname">
        </div>
        <div class="form-group w-full my-2">
          <label class="input-label">Имя</label>
          <input type="text" class="input sm:ml-auto" :value="user.Name" ref="user_name">
        </div>
        <div class="form-group w-full my-2">
          <label class="input-label">Отчество</label>
          <input type="text" class="input sm:ml-auto" :value="user.Lastname" ref="user_lastname">
        </div>
        <div class="form-group w-full my-2">
          <label class="input-label">Дата рождения</label>
          <input type="date" class="input sm:ml-auto" :value="$root.FormatInputDate(user.BirthDate)" ref="user_birthdate">
        </div>
        <div class="form-group w-full my-2">
          <label class="input-label">Пол</label>
          <select class="input sm:ml-auto" :value="user.Gender" ref="user_gender">
            <option value="">Не выбрано</option>
            <option value="Муж.">Муж.</option>
            <option value="Жен.">Жен.</option>
          </select>
        </div>
        <div class="form-group w-full my-2">
          <label class="input-label">Уровень образования</label>
          <select class="input sm:ml-auto" :value="user.EducationLvl" ref="user_education_lvl">
            <option value="">Не выбрано</option>
            <option value="Среднее общее">Среднее общее</option>
            <option value="Основное">Основное</option>
            <option value="Неоконченное основное">Неоконченное основное</option>
            <option value="Среднее профессиональное образование">Среднее профессиональное образование</option>
            <option value="Неоконченное среднее профессиональное образование">Неоконченное среднее профессиональное образование</option>
            <option value="Высшее">Высшее</option>
            <option value="Неоконченное высшее">Неоконченное высшее</option>
          </select>
        </div>
        <div class="form-group w-full my-2" v-if="user.Post !== undefined && user.Post !== null">
          <label class="input-label">Занимаемая должность</label>
          <input type="text" class="input sm:ml-auto" :value="user.Post.Title" ref="user_post">
        </div>
        <div class="form-group w-full my-2" v-if="user.Post !== undefined && user.Post !== null">
          <label class="input-label">Дата назначения</label>          
          <input type="date" class="input sm:ml-auto" :value="$root.FormatInputDate(user.Post.Date)" ref="user_post_date">
        </div>
        <div class="form-group w-full my-2" v-if="user.Role == 'listener'">
          <label class="input-label">Место обучения</label>
          <input type="text" class="input sm:ml-auto" :value="user.StudyPlace" ref="user_study_place">
        </div>
        <div class="form-group w-full my-2" v-if="user.Role == 'listener'">
          <label class="input-label">Место работы</label>
          <input type="text" class="input sm:ml-auto" :value="user.WorkPlace" ref="user_work_place">
        </div>
        <div class="form-group w-full my-2" v-if="user.Role == 'worker'">
          <label class="input-label">Опыт работы</label>
          <input type="number" class="input sm:ml-auto" :value="user.Exp" ref="user_work_exp">
        </div>
        <div class="form-group w-full my-2" v-if="user.Role == 'worker'">
          <label class="input-label">Опыт преподавательской работы</label>
          <input type="number" class="input sm:ml-auto" :value="user.EducationExp" ref="user_education_exp">
        </div>
        <div class="form-group w-full my-2">
          <label class="input-label">ОВЗ</label>
          <input class="checkbox sm:ml-auto" type="checkbox" :checked="user.OVZ" ref="user_ovz">
        </div>
        <div class="form-group w-full my-2">
          <label class="input-label">Инвалидность</label>
          <input class="checkbox sm:ml-auto" type="checkbox" :checked="user.Disability" ref="user_disability">
        </div>
        <div class="flex flex-col my-2">
          <label class="input-label mr-auto">Почты</label>
          <editable-data-list :data="user.Emails.slice()" listID="ue" key="ue" ref="ue"/>
        </div>
        <div class="flex flex-col my-2">
          <label class="input-label mr-auto">Номера телефонов</label>
          <editable-data-list :data="user.Phones.slice()" listID="up" key="up" ref="up"/>
        </div>
        <div class="flex flex-col my-2" v-if="user.Qualifications !== undefined && user.Qualifications !== null">
          <label class="input-label mr-auto">Квалификации</label>
          <editable-data-list :data="user.Qualifications.slice()" listID="uq" key="uq" ref="uq"/>
        </div>
        <div class="flex flex-col my-2" v-if="user.Role == 'worker'">
          <label class="input-label mr-auto">Учёные степени</label>
          <editable-data-list :data="user.Degrees.slice()" listID="ud" key="ud" ref="ud"/>
        </div>
        <div class="flex flex-col my-2" v-if="user.Role == 'worker'">
          <label class="input-label mr-auto">Законченные учебные заведения</label>
          <editable-data-list :data="user.Establishments.slice()" listID="uest" key="uest" ref="uest"/>
        </div>
      </div>
      <div class="modal-dialog-footer">
        <button type="button" class="modal-dialog-footer-button" @click="$root.HideModal('#ChangeRoleInfo')">Закрыть</button>
        <button type="submit" class="modal-dialog-footer-button">Изменить</button>
      </div>
    </form>
  </div>

  <div class="modal dark:text-white" id="SeeProgram" @click="$root.HideModal('#SeeProgram')">
    <div class="modal-dialog max-w-5xl" @click="(e)=>{e.stopPropagation()}">
      <div class="modal-dialog-header">
          <p class="modal-dialog-title">Просмотр данных программы</p>
          <button type="button" class="ml-auto" @click="$root.HideModal('#SeeProgram')">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </button>
      </div>
        <div class="modal-dialog-body" v-if="currentProgram !== null">
          <div class="flex flex-col sm:flex-row sm:justify-between my-2">
            <p class="subtitle">Тип</p>
            <p>{{user.Programs[currentProgram].Type}}</p>
          </div>
          <div class="flex flex-col sm:flex-row sm:justify-between my-2">
            <p class="subtitle">Аббревиатура</p>
            <p>{{user.Programs[currentProgram].Abbreviation}}</p>
          </div>
          <div class="flex flex-col sm:flex-row sm:justify-between my-2">
            <p class="subtitle">Название</p>
            <p>{{user.Programs[currentProgram].Title}}</p>
          </div>
          <div class="flex flex-col sm:flex-row sm:justify-between my-2">
            <p class="subtitle">Кол-во часов</p>
            <p>{{user.Programs[currentProgram].HourNumber}}</p>
          </div>
          <div class="flex flex-col sm:flex-row sm:justify-between my-2">
            <p class="subtitle">Профессия</p>
            <p>{{user.Programs[currentProgram].Profession.Title.trim() !== "" ? `${user.Programs[currentProgram].Profession.Title.trim()}[${user.Programs[currentProgram].Profession.Code}]` : ''}}</p>
          </div>
          <div class="flex flex-col">
            <p class="subtitle">Файлы</p>
            <div class="overflow-auto" style="max-height: 300px;">
              <div class="list-container max-w-[250px]">
                <div class="list-container-item" v-for="(file, index) in user.Programs[currentProgram].Files" :key="'file_' + index">
                  <p>{{file}}</p>
                  <button class="text-blue-600 hover:animate-bounce" @click="DownloadProgramFile(user.ID, user.Programs[currentProgram].ID, file)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import DataList from '@/components/DataList'
import EditableDataList from '@/components/EditableDataList'

export default {
  components: {
    Navigation,
    DataList,
    EditableDataList
  },
  data() {
    return {
      navigationKey: "nav",
      title: "Личный кабинет",
      roles: [],
      user: {
        Roles: [],
        Post: {},
        Programs: [],
        ID: null,
        Login: null,
        Role: null,
        Name: null,
        Surname: null,
        Lastname: null,
        BirthDate: null,
        Gender: null,
        Emails: [],
        Phones: [],
        EducationLvl: null,
        Qualifications: [],
        Degrees: [],
        Establishments: [],
        WorkPlace: null,
        StudyPlace: null,
        Exp: null,
        EducationExp: null,
        OVZ: null,
        Disability: null,
      },
      currentProgram: null,
    }
  },
  methods: {
    SetTitle() {
      document.title = `Samgk DPO - ${this.title}`
    },
    async _ProccessRoles() {
      let res = await fetch(this.$store.state.adminApiAddr + "/v1.0/system/roles/all", {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${this.$root.GetToken()}`,
        },
      }).then(response => {return response.json()})
      .catch(error => {
        this.$root.Fatal()
      })

      let roles = []

      for (var i in res["data"]["roles"]) {
        let role = res["data"]["roles"][i]
        roles.push({ ID: role["id"], Title: role["title"] })
      }

      this.roles = roles
    },
    async _ProccessData() {
      try {
        this.$root.StartLoading()

        var res = await fetch(this.$store.state.apiAddr + "/v1.0/users/me/roles", {
          method: "GET",
          headers: {
            'Authorization': `Bearer ${this.$root.GetToken()}`,
          },
        }).then(response => {return response.json()})
        .catch(error => {
          this.$root.Fatal()
        })

        let roles = []

        for (var i in res["data"]["roles"]) {
          roles.push(res["data"]["roles"][i]["title"])
        }

        this.user.Roles = roles

        var res = await fetch(this.$store.state.apiAddr + "/v1.0/users/me/", {
          method: "GET",
          headers: {
            'Authorization': `Bearer ${this.$root.GetToken()}`,
          },
        }).then(response => { return response.json() })
        .catch(error => {
          this.$root.Fatal()
        })

        if (res["error"] === undefined) {
          let user = res["data"]["user"]
          let employee = user["worker"]
          let listener = user["listener"]
          let student = user["student"]

          let isEmployee = user["roles"].includes(this.$store.state.employeeRole)
          let isListener = user["roles"].includes(this.$store.state.listenerRole)
          let isStudent = user["roles"].includes(this.$store.state.studentRole)

          this.user.ID = user["id"]
          this.user.Login = user["login"]
          this.user.Role = isEmployee ? "worker" : isStudent ? "student" :  isListener ? "listener" : null

          this.user.Name = isEmployee ? employee["name"] : isStudent ? student["name"] : isListener ? listener["name"] : null
          this.user.Surname = isEmployee ? employee["surname"] : isStudent ? student["surname"] : isListener ? listener["surname"] : null
          this.user.Lastname = isEmployee ? employee["middle_name"] : isStudent ? student["middle_name"] : isListener ? listener["middle_name"] : null
          this.user.BirthDate = isEmployee ? this.$root.FormatDate(employee["date_of_birth"]) : isStudent ? this.$root.FormatDate(student["date_of_birth"]) : isListener ? this.$root.FormatDate(listener["date_of_birth"]) : null
          this.user.Gender = isEmployee ? employee["gender"] : isStudent ? student["gender"] : isListener ? listener["gender"] : null
          this.user.Emails = isEmployee ? employee["emails"] || [] : isStudent ? student["emails"] || [] : isListener ? listener["emails"] || [] : null
          this.user.Phones = isEmployee ? employee["number_phones"] || [] : isStudent ? student["number_phones"] || [] : isListener ? listener["number_phones"] || [] : null
          this.user.OVZ = isEmployee ? employee["ovz"] : isStudent ? student["ovz"] : isListener ? listener["ovz"] : null
          this.user.EducationLvl = isEmployee ? employee["level_of_education"] : isStudent ? student["level_of_education"] : isListener ? listener["level_of_education"] : null
          this.user.Disability = isEmployee ? employee["disability"] : isStudent ? student["disability"] : isListener ? listener["disability"] : null
          this.user.Qualifications = isEmployee ? employee["qualifications"] : isListener ? listener["qualifications"] : null

          this.user.Post = isEmployee 
          ? { Title: `${employee["post"]["title"]}`, Date: `${this.$root.FormatDate(employee["post"]["date_of_taking_office"])}`}
          : isListener 
          ? { Title: `${listener["post"]["title"]}`, Date: `${this.$root.FormatDate(listener["post"]["date_of_taking_office"])}`}
          : null

          let programs = []

          if (this.user.Role == "worker") {
            
            let ad = []
            for (var i in employee["academic_degrees"]) {
                ad.push(`${employee["academic_degrees"][i]["title"]} ${this.$root.FormatDate(employee["academic_degrees"][i]["date_of_assignment"])}`)
            }
            this.user.Degrees = ad
            this.user.Exp = employee["general_experience"]
            this.user.EducationExp = employee["experience_of_teaching_work"]
            this.user.Establishments = employee["completed_educational_institutions"]

            if (employee["programs"] != null) {

              for (var i in employee["programs"]["major"]) {
                var program = await fetch(this.$store.state.aeApiAddr +`/v1.0/programs/by_id/${employee["programs"]["additional"][i]}`, {
                  method: "GET",
                  headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                  },
                }).then(response =>{ return response.json() })
                .catch(error => {
                  this.$root.Fatal()
                })

                program = program["data"]["program"]

                programs.push({
                  Type: "Основная",
                  ID: program["id"],
                  Abbreviation: program["abbreviation"],
                  Title: program["title"],
                  HourNumber: program["number_of_hours"],
                  DocumentType: program["type_document"],
                  EducationType: program["type_of_education"],
                  ProgramType: program["type_of_educational_program"],
                  Profession: {
                    Title: program["profession"]["title"],
                    Code: program["profession"]["code"]
                  },
                  Files: employee["programs"]["files"][program["id"]]
                })
              }

              for (var i in employee["programs"]["additional"]) {
                var program = await fetch(this.$store.state.aeApiAddr +`/v1.0/programs/by_id/${employee["programs"]["additional"][i]}`, {
                  method: "GET",
                  headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                  },
                }).then(response =>{ return response.json() })
                .catch(error => {
                  this.$root.Fatal()
                })

                program = program["data"]["program"]

                programs.push({
                  Type: "Дополнительная",
                  ID: program["id"],
                  Abbreviation: program["abbreviation"],
                  Title: program["title"],
                  HourNumber: program["number_of_hours"],
                  DocumentType: program["type_document"],
                  EducationType: program["type_of_education"],
                  ProgramType: program["type_of_educational_program"],
                  Profession: {
                    Title: program["profession"]["title"],
                    Code: program["profession"]["code"]
                  },
                  Files: employee["programs"]["files"][program["id"]]
                })
              }
            }
          }

          if (this.user.Role == "listener") {
            this.user.WorkPlace = listener["place_of_work"]
            this.user.StudyPlace = listener["place_of_study"]

            if (listener["programs"] != null) {

              for (var i in listener["programs"]["major"]) {
                var program = await fetch(this.$store.state.aeApiAddr +`/v1.0/programs/by_id/${listener["programs"]["additional"][i]}`, {
                  method: "GET",
                  headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                  },
                }).then(response =>{ return response.json() })
                .catch(error => {
                  this.$root.Fatal()
                })

                program = program["data"]["program"]

                programs.push({
                  Type: "Основная",
                  ID: program["id"],
                  Abbreviation: program["abbreviation"],
                  Title: program["title"],
                  HourNumber: program["number_of_hours"],
                  DocumentType: program["type_document"],
                  EducationType: program["type_of_education"],
                  ProgramType: program["type_of_educational_program"],
                  Profession: {
                    Title: program["profession"]["title"],
                    Code: program["profession"]["code"]
                  },
                  Files: listener["programs"]["files"][program["id"]]
                })
              }

              for (var i in listener["programs"]["additional"]) {
                var program = await fetch(this.$store.state.aeApiAddr +`/v1.0/programs/by_id/${listener["programs"]["additional"][i]}`, {
                  method: "GET",
                  headers: {
                    'Authorization': `Bearer ${this.$root.GetToken()}`,
                  },
                }).then(response =>{ return response.json() })
                .catch(error => {
                  this.$root.Fatal()
                })

                program = program["data"]["program"]

                programs.push({
                  Type: "Дополнительная",
                  ID: program["id"],
                  Abbreviation: program["abbreviation"],
                  Title: program["title"],
                  HourNumber: program["number_of_hours"],
                  DocumentType: program["type_document"],
                  EducationType: program["type_of_education"],
                  ProgramType: program["type_of_educational_program"],
                  Profession: {
                    Title: program["profession"]["title"],
                    Code: program["profession"]["code"]
                  },
                  Files: listener["programs"]["files"][program["id"]]
                })
              }

            }
          }

          this.user.Programs = programs
        }

        this.$root.EndLoading()
      } catch (e) {
        console.log(e)
        this.$root.Fatal()
      }

      
    },
    ChangeGeneralInfo(e) {
      e.preventDefault()

      let login = this.$refs.user_login.value

      let roles_inputs = this.$refs.user_roles.children
      
      let roles = []

      for (var index = 0; index < roles_inputs.length; index++) {
        var role_input_container = roles_inputs[index]
        var role_input = role_input_container.querySelector("input[name='role']")
        if (role_input.checked) {
          roles.push(role_input.value)
        }
      }

      fetch(this.$store.state.apiAddr + "/v1.0/users/me/", {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${this.$root.GetToken()}`,
          'Content-Type': 'text/json;charset=utf-8'
        },
        body: JSON.stringify({
          "login": login,
          "roles": roles
        })
      })
      .then(response => response.json())
      .then(res => {
        if (this.$root.HandleFetchError(res)) return
        this.$root.ShowToast("Данные успешно изменены", "success")
        this._ProccessData()
        this._ProccessRoles()
        this.navigationKey = `${this.navigationKey}${Math.floor(Math.random() * 3)}`
      })
      .catch(error => {
        this.$root.Fatal()
      })

    },
    ChangeRoleInfo(e) {
      e.preventDefault()

      let form = e.target

      let surname = this.$refs.user_surname.value
      let name = this.$refs.user_name.value
      let lastname = this.$refs.user_lastname.value
      let birthdate = this.$refs.user_birthdate.value + "T00:00:00Z"
      let gender = this.$refs.user_gender.value
      let education_lvl = this.$refs.user_education_lvl.value
      let post = this.$refs.user_post.value
      let post_date = this.$refs.user_post_date.value + "T00:00:00Z"
      let ovz = this.$refs.user_ovz.checked
      let disability = this.$refs.user_disability.checked

      birthdate = birthdate == "T00:00:00Z" ? undefined : birthdate
      post_date = post_date == "T00:00:00Z" ? undefined : post_date
      
      let emails = this.$refs.ue.GetData()
      let phones = this.$refs.up.GetData()
      let qualifications = this.$refs.uq.GetData()

      if (this.user.Role == 'listener') {
        let study_place = this.$refs.user_study_place.value
        let work_place = this.$refs.user_work_place.value

        fetch(this.$store.state.aeApiAddr + "/v1.0/listener/me/", {
          method: "PUT",
          headers: {
            'Authorization': `Bearer ${this.$root.GetToken()}`,
            'Content-Type': 'text/json;charset=utf-8'
          },
          body: JSON.stringify({
            name: name,
            surname: surname,
            middle_name: lastname,
            date_of_birth: birthdate,
            gender: gender,
            level_of_education: education_lvl,
            post: {
              title: post,
              date_of_taking_office: post_date
            },
            place_of_work: work_place,
            place_of_study: study_place,
            ovz: ovz,
            disability: disability,
            emails: emails,
            number_phones: phones,
            qualifications: qualifications
          })
        })
        .then(response => response.json())
        .then(res => {
          if (this.$root.HandleFetchError(res)) return
          this.$root.ShowToast("Данные успешно изменены", "success")
          this._ProccessData()
        })
        .catch(error => {
          this.$root.Fatal()
        })
      }

      if (this.user.Role == 'worker') {
        let work_exp = Number(this.$refs.user_work_exp.value)
        let education_exp = Number(this.$refs.user_education_exp.value)

        let degrees = []
        let degrees_inputs = this.$refs.ud.GetData()

        for (var i in degrees_inputs) {
          var input_container = degrees_inputs[i]
          var input = input_container.split(" ")

          var date = this.$root.FormatInputDate(input.pop())

          degrees.push({
            "title": input.join(),
            "date_of_assignment": date + "T00:00:00Z"
          })
        }

        let establishments = this.$refs.uest.GetData()

        fetch(this.$store.state.apiAddr + "/v1.0/workers/me/", {
          method: "PUT",
          headers: {
            'Authorization': `Bearer ${this.$root.GetToken()}`,
            'Content-Type': 'text/json;charset=utf-8'
          },
          body: JSON.stringify({
            name: name,
            surname: surname,
            middle_name: lastname,
            date_of_birth: birthdate,
            gender: gender,
            level_of_education: education_lvl,
            post: {
              title: post,
              date_of_taking_office: post_date
            },
            general_experience: work_exp,
            experience_of_teaching_work: education_exp,
            ovz: ovz,
            disability: disability,
            emails: emails,
            number_phones: phones,
            qualifications: qualifications,
            academic_degrees: degrees,
            establishments: establishments
          })
        })
        .then(response => response.json())
        .then(res => {
          if (this.$root.HandleFetchError(res)) return
          this.$root.ShowToast("Данные успешно изменены", "success")
          this._ProccessData()
        })
        .catch(error => {
          this.$root.Fatal()
        })
      }
    },
    async DownloadProgramFile(userID, programmID, fileName) {
      try {
        var res = await fetch(this.$store.state.filesApiAddr + `/v1.0/ae/programs/users/files/${userID}/${programmID}/${fileName}`, {
          method: "GET",
          headers: {
            'Authorization': `Bearer ${this.$root.GetToken()}`,
          },
        })
        .catch(error=> {
          this.$root.ShowToast("Не удалось скачать файл", "error")
        })

        var result = await res.blob()

        var a = document.createElement("a")
        a.setAttribute("href", URL.createObjectURL(result))
        a.setAttribute("download", fileName)
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(a.href)
        a.remove()
      } catch (e) {
        this.$root.ShowToast("Не удалось скачать файл", "error")
      }
    }
  },
  mounted() {
    if (this.$root.fatal) return
    this.SetTitle()
    this.$root.StartLoading()
    this.$root.UpdateToken()
    this.$root.GetRoles().then(()=>{
      if (this.$root.HasRole(this.$store.state.adminRole)) {
        this._ProccessRoles()
      }
      this._ProccessData().then(()=>{
        this.$root.EndLoading()
      })
      
    })
  }
}
</script>
